import React, { Component } from "react";

import "./styles.css";
import AccountInfoCard from "./AccountInfoCard";

export default class AccountInfoContainer extends Component {

  render() {
    var account_cards = this.props.accounts.map(
      account => <AccountInfoCard
                  key={account.account_number}
                  account={account} />
    );

    return (
      <div className="container-body">
        <div className="title-container">
          <a className="title-text">Hi, here are your accounts:</a>
        </div>
        {account_cards}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/LiveTradingView/components/AccountInfoContainer.js